export {
  setHasPatientDataLoaded,
  setPatientName,
  setPatientUHID,
  setPatientDOB,
  setPatientGender,
  setPatientFhirId,
  setPatientBedNumber,
  setPatientRoomNumber,
  setPatientWardName,
  setSelectedPatientIndex,
  setSelectedDeviceIndex,
  setLayout,
  setBedId,
  setBedNumber,
  setAdmissionDate,
  setMasterPatientDetails,
  setCurrentLocation,
  setIpdUpdateMessageLocation,
  setIsDeviceClicked,
  setLocationsList,
  setOnlyLocations,
  setSearchQuery,
  setDoctors,
  addThopNotificationMessage,
  deleteThopNotificationMessage,
  setStatusUpdateCount,
  setIpdUpdateCount,
  setIpdDataUpdateCount,
  setSelectedDevice,
  setDeviceList,
  setIpdUpdateMessage,
  setSelectedCategory,
  addProrithmNotification,
  removeProrithmNotification,
  markProrithmNotificationAsRead,
  setProrithmWebSocketMessage,
  setProrithmWebSocketCount,
  setProrithmWebSocketConnectionStatus,
} from './appSlice'

// Action type string constants — now reflect RTK slice format 'app/actionName'.
// Used by store.tsx for the redux-state-sync blacklist.
export const PATIENT_DATA_LOADED = 'app/setHasPatientDataLoaded'
export const PATIENT_NAME = 'app/setPatientName'
export const PATIENT_UHID = 'app/setPatientUHID'
export const PATIENT_DOB = 'app/setPatientDOB'
export const PATIENT_GENDER = 'app/setPatientGender'
export const PATIENT_FHIR_ID = 'app/setPatientFhirId'
export const PATIENT_BED_NUMBER = 'app/setPatientBedNumber'
export const PATIENT_ROOM_NUMBER = 'app/setPatientRoomNumber'
export const PATIENT_WARD_NAME = 'app/setPatientWardName'
export const SELECTED_PATIENT_INDEX = 'app/setSelectedPatientIndex'
export const SELECTED_DEVICE_INDEX = 'app/setSelectedDeviceIndex'
export const LAYOUT = 'app/setLayout'
export const BED_ID = 'app/setBedId'
export const BED_NUMBER = 'app/setBedNumber'
export const ADMISSION_DATE = 'app/setAdmissionDate'
export const MASTER_PATIENT_DETAILS = 'app/setMasterPatientDetails'
export const CURRENT_LOCATION = 'app/setCurrentLocation'
export const IPD_UPDATE_MESSAGE_LOCATION = 'app/setIpdUpdateMessageLocation'
export const IS_DEVICE_CLICKED = 'app/setIsDeviceClicked'
export const LOCATIONS_LIST = 'app/setLocationsList'
export const ONLY_LOCATIONS = 'app/setOnlyLocations'
export const SEARCH_QUERY = 'app/setSearchQuery'
export const DOCTORS_LIST = 'app/setDoctors'
export const THOP_NOTIFICATION_MESSAGES_ADD = 'app/addThopNotificationMessage'
export const THOP_NOTIFICATION_MESSAGES_DELETE =
  'app/deleteThopNotificationMessage'
export const STATUS_UPDATE_COUNT = 'app/setStatusUpdateCount'
export const IPD_UPDATE_COUNT = 'app/setIpdUpdateCount'
export const IPD_DATA_UPDATE_COUNT = 'app/setIpdDataUpdateCount'
export const SELECTED_DEVICE = 'app/setSelectedDevice'
export const DEVICE_LIST = 'app/setDeviceList'
export const IPD_UPDATE_MESSAGE = 'app/setIpdUpdateMessage'
export const SELECTED_CATEGORY = 'app/setSelectedCategory'
export const PRORITHM_NOTIFICATIONS_ADD = 'app/addProrithmNotification'
export const PRORITHM_NOTIFICATIONS_REMOVE = 'app/removeProrithmNotification'
export const PRORITHM_NOTIFICATIONS_MARK_READ =
  'app/markProrithmNotificationAsRead'
export const PRORITHM_WEBSOCKET_MESSAGE = 'app/setProrithmWebSocketMessage'
export const PRORITHM_WEBSOCKET_COUNT = 'app/setProrithmWebSocketCount'
export const PRORITHM_WEBSOCKET_CONNECTION_STATUS =
  'app/setProrithmWebSocketConnectionStatus'
